import type { MentorProfileDraft } from "@/lib/api/mentor-profile";

function storageKey(reviewId: string, roundKey: string) {
  return `mentor-profile:revision-baseline:${reviewId}:${roundKey}`;
}

/**
 * Freeze the draft as it looked at the start of a changes-requested round.
 * Survives refresh in the same browser so flagged-section diffs stay valid
 * after autosave / refresh in the same browser tab.
 */
export function readOrWriteRevisionBaseline(
  reviewId: string,
  roundKey: string,
  draft: MentorProfileDraft,
): MentorProfileDraft {
  if (typeof window === "undefined") {
    return structuredClone(draft);
  }

  const key = storageKey(reviewId, roundKey);
  try {
    const existing = window.sessionStorage.getItem(key);
    if (existing) {
      return JSON.parse(existing) as MentorProfileDraft;
    }
  } catch {
    // fall through and write a fresh snapshot
  }

  const snapshot = structuredClone(draft);
  try {
    window.sessionStorage.setItem(key, JSON.stringify(snapshot));
  } catch {
    // Private mode / quota — still return an in-memory snapshot for this mount.
  }
  return snapshot;
}

export function clearRevisionBaseline(reviewId: string, roundKey: string) {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(storageKey(reviewId, roundKey));
  } catch {
    // ignore
  }
}
